<template>
  <div>
    <div style="margin-top: -24px; margin-left: 15px">
      <el-input
        size="small"
        style="width: 400px"
        placeholder="输入AB包名称查询"
        @keyup.enter="handleSearchByText"
        v-model="searchText"
      >
        <template #append>
          <el-button @click="handleSearchByText"
            ><i class="iconfont icon-sousuo"></i> <span>查询</span></el-button
          >
        </template>
      </el-input>
    </div>
    <div v-loading="loading" class="table-wrapper">
      <el-table
        :data="tableData"
        size="default"
        @sort-change="handleSortChange"
        height="calc(100vh - 260px)"
        border
      >
        <el-table-column width="66">
          <template #default="scope">
            <el-button
              @click="handleRowClick(scope.row)"
              link
              type="primary"
              size="small"
              style="padding: 0"
            >
              <i class="iconfont icon-level-down"></i>
              <span>查看</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="bundle_name" label="boundle名称">
        </el-table-column>
        <el-table-column
          prop="bundle_size"
          label="文件大小"
          sortable="custom"
          width="120"
        >
          <template #default="scope">
            {{ humanSizePackage(scope.row.bundle_size) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contain_assets"
          label="包含资源数"
          sortable="custom"
          width="130"
        >
        </el-table-column>
        <el-table-column
          prop="all_dependencies_bundles"
          label="总依赖AB包"
          sortable="custom"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="direct_dependencies_bundles"
          label="直接依赖的AB包"
          sortable="custom"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="rev_dependencies_scenes"
          label="被引用场景数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="rev_direct_dependencies_bundles"
          label="被直接依赖的AB包"
          width="150"
        >
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <el-pagination
          background
          :page-size="count"
          :current-page="cursor"
          :total="total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, onMounted } from "vue";
import { humanSizePackage } from "@/Utils/UtilTools";
import { apiPackageParseBoundle } from "@/Api/AppApi";

const props = defineProps(["param"]);
const emit = defineEmits(["selectRow"]);

onMounted(() => {
  loadData(searchText.value);
});

const searchText = ref("");
const count = ref(30);
const cursor = ref(1);
const total = ref(0);
function handleSearchByText() {
  count.value = 30;
  cursor.value = 1;
  loadData(searchText.value);
}

let sortColumn = "";
let order = "";
function handleSortChange(evt) {
  sortColumn = evt.prop;
  order = evt.order;
  loadData(searchText.value);
}

const tableData = ref([]);

function handleRowClick(row) {
  const data = {
    viewType: "boundledetail",
    name: row.bundle_name,
  };
  emit("selectRow", data);
}

function handlePageChange(pagenum) {
  cursor.value = pagenum;
  loadData(searchText.value);
}

const loading = ref(false);
async function loadData(search) {
  const params = {
    version_id: props.param.versionid,
    cursor: cursor.value,
    count: count.value,
  };

  if (search != undefined && search.length > 0) {
    params.bundle_name = search;
  }
  if (sortColumn != undefined && sortColumn.length > 0) {
    params.sort_field = sortColumn;
  }
  if (order != undefined && order.length > 0) {
    params.order = order;
  }

  loading.value = true;
  const res = await apiPackageParseBoundle(props.param.type, params);
  loading.value = false;

  if (res.code === 0) {
    total.value = res.data.total;
    tableData.value = res.data.list;
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  margin-top: 8px;
  width: 100%;
  background: #fff;
  padding: 15px 15px 0 15px;
  height: calc(100vh - 190px);

  :deep() {
    .el-table__inner-wrapper,
    .el-scrollbar__wrap {
      height: 100% !important;
    }

    .el-table__body-wrapper {
      height: calc(100% - 40px) !important;
    }
  }
}

.pagination-wrapper {
  display: flex;
  background-color: #ffffff;
  justify-content: center;
  padding: 5px 0;
  height: 46px;
}
</style>
